"use strict";
/*
 * Created on 04 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * DTO object encapsulating {@link SelloutReleaseItem release item} and {@link SelloutReleasePart} attached to that item.
 *
 * Association is performed based on {@link SelloutReleaseItem.categoryIds} and {@link SelloutReleasePart.productCategoryId}.
 *
 * @author JMe
 */


var SelloutReleaseItemWithPart =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemWithPart, _DomainObject_1$Domai);

  /**
   * @param releaseItem single sellout release item
   * @param releasePart sellout release part with which the item is associated
   */
  function SelloutReleaseItemWithPart(releaseItem, releasePart) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemWithPart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemWithPart).call(this));
    _this.releaseItem = releaseItem;
    _this.releasePart = releasePart;
    return _this;
  }

  return SelloutReleaseItemWithPart;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemWithPart = SelloutReleaseItemWithPart;